import angular from 'angular';

import component from './menu-category-manage.component';

const ManageCategoryModule = angular
    .module('control-room.menus.components.menu-category-manage', [])
    .component('crMenuCategoryManage', component);

export default ManageCategoryModule;
